import React, { useContext } from 'react';

import { NOOP } from '@lootboy/lib/utils';

import { CookieConsentsContext } from '~/components/CookieConsentsProvider';
import Sovendus from '~/components/Sovendus';

import { ECookieProcessingServices } from '~/constants/cmp';
import { IReward } from '~/interfaces/IReward';
import Scratch from '~/views/CardDetailView/RewardCodeView/Scratch';

interface ISovendusWithConsentProps {
  country: string;
  reward: IReward;
}

const SovendusWithConsent: React.FC<ISovendusWithConsentProps> = ({
  country,
  reward,
}) => {
  const {
    consents: { [ECookieProcessingServices.SOVENDUS]: hasSovendusConsent },
    acceptService,
  } = useContext(CookieConsentsContext);

  if (!hasSovendusConsent) {
    return (
      <Scratch
        onOpened={() => {
          acceptService(ECookieProcessingServices.SOVENDUS).catch(NOOP);
        }}
      />
    );
  }

  return (
    <Sovendus
      reward={reward}
      country={country}
    />
  );
};

export default SovendusWithConsent;
